import { render, staticRenderFns } from "./basicInfo.vue?vue&type=template&id=1d32bd65&scoped=true&"
import script from "./basicInfo.vue?vue&type=script&lang=js&"
export * from "./basicInfo.vue?vue&type=script&lang=js&"
import style0 from "./basicInfo.vue?vue&type=style&index=0&id=1d32bd65&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d32bd65",
  null
  
)

export default component.exports